import React, { Fragment } from "react";

import Page from "../../components/Page";
import ProjectList from "../../components/ProjectList";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";
import CenteredPageContentContainer from "../../components/CenteredPageContentContainer";
import PaperContainer from "../../components/PaperContainer";

const ProjectPage = () => (
  <Page title="Projecten">
    <Fragment>
      <CenteredPageContentContainer>
        <PaperContainer title="Projecten">
          <ProjectList />
        </PaperContainer>
      </CenteredPageContentContainer>
      <Fab
        variant="circular"
        color="primary"
        style={{ position: "fixed", bottom: 40, right: 40 }}
        onClick={() => {
          window.location.href = `/project/create`;
        }}
      >
        <AddIcon />
      </Fab>
    </Fragment>
  </Page>
);

export default ProjectPage;



// WEBPACK FOOTER //
// ./src/pages/Project/ProjectPage.js